import { API_PATHS } from "../constants/api.constants";

const SCRIPT_ATTR = "data-google-places-loader";
let googlePlacesPromise;

export function loadGooglePlacesScript() {
  if (window.google?.maps?.places) {
    return Promise.resolve();
  }

  if (googlePlacesPromise) {
    return googlePlacesPromise;
  }

  googlePlacesPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(
      `script[${SCRIPT_ATTR}], script[src^="https://maps.googleapis.com/maps/api/js"]`
    );

    if (existing) {
      existing.addEventListener("load", resolve, { once: true });
      existing.addEventListener(
        "error",
        () => reject(new Error("Unable to load Google Places")),
        { once: true }
      );
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_PATHS.googlemapsapikey}&libraries=places`;
    script.setAttribute(SCRIPT_ATTR, "true");
    script.async = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error("Unable to load Google Places"));
    document.body.appendChild(script);
  }).catch((error) => {
    googlePlacesPromise = undefined;
    throw error;
  });

  return googlePlacesPromise;
}
